// Quiz multi-étapes avec jauge — Harnais Chien Expert
(function () {
  'use strict';

  var COLLECTIONS = {
    'anti-traction': { label: 'Harnais anti-traction', url: '/collections/harnais-anti-traction-chien',
      desc: "Votre chien tire en laisse et vous avez besoin de contr\xf4le. L'anneau frontal le redirige naturellement sans forcer sur le cou." },
    'anti-fugue':    { label: 'Harnais anti-fugue 3 points', url: '/collections/harnais-anti-fugue-chien',
      desc: "Votre chien s'\xe9chappe, est craintif ou appartient \xe0 une race fine. La sangle abdominale bloque toute tentative d'\xe9vasion." },
    'canicross':     { label: 'Harnais canicross / sport', url: '/collections/harnais-canicross',
      desc: "Pour les activit\xe9s sportives, il faut un harnais qui absorbe les tractions s\xe8ches et lib\xe8re totalement les \xe9paules." },
    'randonnee':     { label: 'Harnais randonn\xe9e', url: '/collections/harnais-pour-chien-randonnee',
      desc: "Con\xe7u pour les longues distances : poign\xe9e de s\xe9curit\xe9, mat\xe9riaux r\xe9sistants et confort sur plusieurs heures." },
    'y':             { label: 'Harnais en Y (anatomique)', url: '/collections/harnais-chien-y',
      desc: "Votre chien marche bien et vous cherchez avant tout le confort. La coupe Y lib\xe8re les \xe9paules et respecte la morphologie naturelle." },
    'levage':        { label: 'Harnais de levage / soutien', url: '/collections/harnais-chien-handicape',
      desc: "Pour un chien en r\xe9\xe9ducation ou avec des difficult\xe9s de mobilit\xe9, la poign\xe9e dorsale et la sangle abdominale sont indispensables." },
    'voiture':       { label: 'Harnais voiture', url: '/collections/harnais-chien-voiture',
      desc: "Si les trajets sont fr\xe9quents, un harnais homologu\xe9 avec anneau ceinture garantit la s\xe9curit\xe9 de votre chien en cas de freinage brusque." }
  };

  function initQuiz(quiz) {
    var steps     = Array.from(quiz.querySelectorAll('.bqm-step'));
    var bar       = quiz.querySelector('.bqm-bar-fill');
    var stepLabel = quiz.querySelector('.bqm-step-label');
    var stepPct   = quiz.querySelector('.bqm-step-pct');
    var stepsWrap = quiz.querySelector('.bqm-steps');
    var header    = quiz.querySelector('.bqm-header');
    var resultBox = quiz.querySelector('.bqm-result-box');
    var total     = steps.length;
    var scores    = {};

    function reset() { Object.keys(COLLECTIONS).forEach(function(k){ scores[k]=0; }); }

    function updateBar(idx) {
      var pct = Math.round(((idx + 1) / total) * 100);
      bar.style.width = pct + '%';
      if (stepLabel) stepLabel.textContent = 'Question ' + (idx + 1) + ' / ' + total;
      if (stepPct)   stepPct.textContent   = pct + '%';
    }

    function showStep(idx) {
      steps.forEach(function(s,i){ s.classList.toggle('bqm-step--active', i===idx); });
      updateBar(idx);
    }

    function showResult() {
      var winner = Object.keys(scores).reduce(function(a,b){ return scores[a]>=scores[b]?a:b; });
      var col = COLLECTIONS[winner];
      resultBox.innerHTML =
        '<p class="bqm-result-label">Votre harnais id\xe9al :</p>' +
        '<p class="bqm-result-title">' + col.label + '</p>' +
        '<p class="bqm-result-desc">' + col.desc + '</p>' +
        '<a class="bqm-result-cta" href="' + col.url + '">Voir la s\xe9lection →</a>' +
        '<button class="bqm-restart">Recommencer le quiz</button>';
      stepsWrap.style.display = 'none';
      header.style.display    = 'none';
      resultBox.style.display = 'block';
      resultBox.querySelector('.bqm-restart').addEventListener('click', restart);
      resultBox.scrollIntoView({ behavior:'smooth', block:'nearest' });
    }

    function restart() {
      reset();
      stepsWrap.style.display = '';
      header.style.display    = '';
      resultBox.style.display = 'none';
      resultBox.innerHTML     = '';
      steps.forEach(function(s){
        s.querySelectorAll('.bqm-option').forEach(function(o){ o.classList.remove('bqm-option--selected'); });
      });
      showStep(0);
    }

    steps.forEach(function(step, idx) {
      step.querySelectorAll('.bqm-option').forEach(function(opt) {
        opt.addEventListener('click', function(e) { e.preventDefault();
          if (opt.classList.contains('bqm-option--selected')) return;
          step.querySelectorAll('.bqm-option').forEach(function(o){ o.classList.remove('bqm-option--selected'); });
          opt.classList.add('bqm-option--selected');
          (opt.getAttribute('data-scores')||'').split(',').forEach(function(p){
            var kv=p.split(':'); if(kv.length===2) scores[kv[0].trim()]+=(parseInt(kv[1].trim(),10)||0);
          });
          setTimeout(function(){ idx<total-1 ? showStep(idx+1) : showResult(); }, 300);
        });
      });
    });

    reset(); showStep(0);
  }

  function init(){ document.querySelectorAll('.blog-quiz-multi').forEach(initQuiz); }
  document.readyState==='loading' ? document.addEventListener('DOMContentLoaded',init) : init();
})();
